import * as SOURCES from '../../constants/sources';

export const genders = ['male', 'female'];
export const employments = Object.values(SOURCES.EMPLOYMENT_VALUES);
export const solvencyProof = SOURCES.INCOME_CONFIRMATION_SOURCE.map(({ value }) => value);
export const educations = SOURCES.EDUCATION_SOURCE.map(({ value }) => value);
export const properties = SOURCES.PROPERTY_TYPE_SOURCE.map(({ value }) => value);
export const maritalStatuses = SOURCES.FAMILY_STATUS_SOURCE.map(({ value }) => value);
export const opfs = ['OOO', 'IP', 'AO', 'PAO', 'GBU', 'OAO', 'FGKU', 'MBU', 'F', 'ZAO', 'UNKNOWN'];
export const carManufacturers = Object.values(SOURCES.CAR_VALUES);
export const areasOfEmployment = SOURCES.AREA_OF_EMPLOYMENT_SOURCE.map(({ value }) => value);
export const creditSecurities = Object.values(SOURCES.CREDIT_SECURITY_VALUES);
